import { isString } from "../utils/schemaUtils";

export interface LinearDocumentPayload {
  type: "linear_document";
  id: string;
  title: string;
  content: string;
  project?: string;
  updatedAt: string;
  url: string;
}

export const parseLinearDocumentPayload = (v: unknown): LinearDocumentPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_document") return null;
  if (!isString(r.id)) return null;
  if (!isString(r.title)) return null;
  if (!isString(r.content)) return null;
  if (r.project !== undefined && !isString(r.project)) return null;
  if (!isString(r.updatedAt)) return null;
  if (!isString(r.url)) return null;
  return {
    type: "linear_document",
    id: r.id,
    title: r.title,
    content: r.content,
    project: r.project,
    updatedAt: r.updatedAt,
    url: r.url,
  };
};
